export const REQUEST_CUSTOMER_DATA = 'REQUEST_CUSTOMER_DATA';
export const RECEIVE_CUSTOMER_DATA = 'RECEIVE_CUSTOMER_DATA';
export const INVALIDATE_CUSTOMER_DATA = 'INVALIDATE_CUSTOMER_DATA';
export const RECEIVE_CREATE_CUSTOMER = 'RECEIVE_CREATE_CUSTOMER';
export const RECEIVE_UPDATE_CUSTOMER = 'RECEIVE_UPDATE_CUSTOMER';
export const RECEIVE_DELETE_CUSTOMER = 'RECEIVE_DELETE_CUSTOMER';
